import React from 'react';
import { Remote } from '@okapi/remote';
import { InspirationGallery } from 'modules/model-json';

type TProps = {
  regionId: string;
  inspirationGalleryData?: InspirationGallery;
  analyticsName?: string;
};

export const InspGalleryRemote: React.FC<TProps> = ({
  regionId,
  inspirationGalleryData,
  analyticsName = '',
}) => {
  if (!inspirationGalleryData) {
    return null;
  }

  return (
    <Remote
      id="inspiration-gallery-remote"
      data={{
        inspirationGalleryDataFromModel: inspirationGalleryData,
        regionId,
        paddings: false,
        analyticsName,
      }}
      key="inspiration-gallery/root"
      widget="inspiration-gallery/root"
      fallback={null}
    />
  );
};
